<template>
  <normal-dialog
    :visible="visible"
    :before-close="resetDialog"
    @update:visible="updateVisibleHandle"
    append-to-body
    top="5%"
  >
    <template slot="title">缴费条款</template>
    <p>
      缴费条款
      <br><br>
      欢迎使用多彩提供的服务费缴费支付服务（以下简称“本服务”），为了保障用户的权益，在使用本服务前，用户应当阅读并遵守本协议。一经开通或使用本服务，即视为用户已理解并接受本协议和附属协议。
      <br><br>
      1、服务内容
      <br><br>
      多彩服务费缴费提供支付宝和微信两种缴费方式，用户可通过本服务缴纳平台服务费。
      <br><br>
      2、操作方法
      <br><br>
      2.1 登陆PC端后台，通过菜单【运营商账户】，可以进行物联网卡续费。(建议续费前，先通过【服务费管理】->【按月服务费用】查阅自己的服务费详情，核实无误后进行缴纳)
      <br><br>
      2.2 登录PC端后台，根据弹出的缴费提醒直接进行扫码缴费。
      <br><br>
      2.3 登录微信小程序"多彩运营商"进行服务费缴费。
      <br><br>
      3、风险提示
      <br><br>
      缴费时，用户请务必仔细确认自己服务费缴费数额及所选择的缴费方式。若因用户自身操作不当或不及时缴纳服务费造成用户损失的情形时，多彩将不会作出任何补偿。
      <br><br>
      4、缴费失实的处理方法
      <br><br>
      若因系统缴费方式原因造成用户缴费失实并经查证属实的，平台将根据用户充值情况进行如下处理：
      <br><br>
      5.1 因缴费方式原因，造成系统缴费额小于用户实际缴费额的，多彩平台予以补其差额；
      <br><br>
      5.2 因缴费方式原因，造成系统缴费额大于用户实际充值额的，多彩平台有权追回差额；
      <br><br>
      6、服务变更、中断或终止
      <br><br>
      6.1多彩平台可以随时变更服务或更新本协议的条款，但会在相关的页面上及时提示修改内容。修改后的服务协议一旦在页面上公布即代替原来的服务协议。用户可随时前往多彩平台服务费缴费页面查阅最新缴费协议。
      <br><br>
      6.2 如遇到系统维护、升级等影响本服务操作的情形时，多彩平台暂停本服务并事先进行告知。
      <br><br>
      7、不可抗力及其他免责事由
      <br><br>
      7.1 在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。 不可抗力是指不能预见、不能克服、不能避免且对一方或双方造成重大影响的客观事件，包括但不限于洪水、地震、瘟疫和风暴等自然灾害以及战争、动乱、政府行为、黑客攻击等社会事件。 出现上述情况时，多彩平台将努力在第一时间与相关单位配合及时进行修复，但由此给您造成的损失多彩平台将在法律允许的范围内免责。
      <br><br>
      7.2 在法律允许的范围内，多彩平台对以下情形导致的服务中断或受阻不承担责任：
      <br><br>
      （1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；
      <br><br>
      （2）用户或多彩平台的电脑软件、系统、硬件和通信线路出现故障；
      <br><br>
      （3）用户操作不当；
      <br><br>
      （4）用户通过非多彩平台授权的方式使用本服务；
      <br><br>
      （5）银行系统或支付平台出现故障；
      <br><br>
      （6）其他多彩平台无法控制或合理预见的情形。
      <br><br>
      7.3 用户同意保障和维护多彩平台及其他用户的利益，如因用户违反有关法律、法规或本协议项下的任何条款而给多彩平台或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。
    </p>
  </normal-dialog>
</template>

<script>
import dialogMixin from '../../mixins/dialog';

export default {
  mixins: [dialogMixin],
  props: {},
  computed: {},
};
</script>
